import { images } from "../../../../constants/index"
import "./helplineImage.css"
const HelpLineImage = () => {
    return (
        <div className="helplineimg">
            <img src={ images.Helpline} alt="" />
        </div>
    )
}
export default HelpLineImage